export default "__VITE_ASSET__312633fb__"